<template>
  <section
    class="section section-shaped section-lg my-0 c-background"
    style="padding-top: 4rem;"
  >
    <!-- <div class="lp-bg shape shape-style-1 shape-default">
    </div> -->
    <div class="container">
      <div class="row">
        <div class="col-xs" style="width: 100%;">
          <div class="logoHolder">
            <img :src="logoDark || logoLight" alt="" class="logo" />
          </div>
        </div>
      </div>
      <div class="row" style="margin-bottom: 4rem;">
        <div class="col-sm">
          <div class="newApp">
            <h3>New Loan Application</h3>
            <base-button type="success" @click="$router.push('register')"
              >Start Now</base-button
            >
          </div>
        </div>
        <div class="divider"></div>
        <div class="col-sm">
          <div class="loginHolder">
            <div class="loader" v-if="loading" :class="{ bringIn: loading }">
              <div class="loader-box">
                <div
                  class="border-1"
                  :style="{ border: '2px solid ' + iconSuccess }"
                  :class="{ spin1: checking, spin3: !checking }"
                ></div>
                <div
                  class="border-2"
                  :style="{ border: '2px solid ' + iconColor }"
                  :class="{ spin2: checking, spin3: !checking }"
                  v-if="checking"
                ></div>
                <i
                  v-if="checking"
                  class="ni ni-key-25"
                  :style="{ color: iconColor }"
                ></i>
                <i
                  v-if="!checking"
                  class="ni ni-lock-circle-open unlock"
                  :style="{ color: iconSuccess }"
                ></i>
              </div>
            </div>
            <template>
              <form role="form" @keydown.enter="attemptLogin">
                <h4>
                  Customer Login<small
                    v-if="attemptsLeft && !questionModal"
                    :class="{
                      'text-danger': attemptsLeft == 1,
                      'text-warning': attemptsLeft == 2,
                      'text-success': attemptsLeft == 3,
                    }"
                    >: {{ attemptsLeft }} Attempts Left</small
                  >
                </h4>
                <label for="email">Email</label>
                <base-input
                  id="email"
                  v-model="email"
                  class="mb-3"
                  placeholder="Email"
                  addon-left-icon="ni ni-email-83"
                  :class="{ opacityChange: loading }"
                  :valid="emailValid"
                  @change="emailValid = null"
                >
                </base-input>
                <label for="password">Password</label>

                <base-input
                  id="password"
                  v-model="password"
                  type="password"
                  placeholder="Password"
                  addon-left-icon="ni ni-lock-circle-open"
                  :class="{ opacityChange: loading }"
                  :valid="passValid"
                  @change="passValid = null"
                >
                </base-input>
                <base-alert type="danger" dismissible v-if="error">
                  <span class="alert-inner--icon"
                    ><i class="ni ni-key-25"></i
                  ></span>
                  <span class="alert-inner--text">{{ error }}</span>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </base-alert>
                <div
                  class="text-center"
                  style="display: flex;justify-content: center;align-items: center;"
                >
                  <base-button
                    type="primary"
                    :class="{ opacityChange: loading }"
                    class="my-4"
                    @click="attemptLogin"
                    >Sign In</base-button
                  >
                </div>
              </form>
            </template>
          </div>
          <div class="row mt-3">
            <div class="col-6">
              <a
                @click="forgotPassword = true"
                style="cursor: pointer"
                class="text-light"
              >
                <small>Forgot password?</small>
              </a>
            </div>
            <div class="col-6 text-right">
              <router-link :to="{ name: 'register' }" class="text-light">
                <small>Create new account</small>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <modal
        :show.sync="questionModal"
        body-classes="p-0"
        modal-classes="modal-dialog-centered modal-md"
      >
        <card
          shadow
          header-classes="bg-white pb-5"
          body-classes="px-lg-5 py-lg-5"
          class="border-0"
          style="color: rgba(50, 50, 93, 1) !important"
        >
          <template>
            <div class="py-3 text-center" style="padding-top: 0 !important;">
              <i
                class="fa fa-shield fa-3x"
                style="color: rgb(45, 206, 137);border: 2px solid;border-radius: 50%;padding: 14px 22px;"
              ></i>
              <p class="lead">
                Looks like you have not signed in on this device before. For
                security, please answer the question below.
              </p>
            </div>
            <form
              role="form"
              @keydown.enter="checkSecurityQuestion"
              onSubmit="return false;"
            >
              <label for="securityQuestion">{{ questions.Question }}</label>
              <base-input
                id="securityQuestion"
                class="mb-3"
                placeholder="Answer"
                addon-left-icon="fa fa-question-circle-o"
                v-model="answer"
                :valid="quValid"
              >
              </base-input>
              <div
                v-if="deviceError"
                style="margin-bottom: 10px;margin-top: -10px;font-size: 14px;"
                :class="{
                  'text-danger': attemptsLeft == 1,
                  'text-warning': attemptsLeft == 2,
                  'text-warning': deviceError,
                  'text-success': attemptsLeft == 3,
                }"
              >
                {{ deviceError }}
                {{
                  attemptsLeft ? "( " + attemptsLeft + " Attempts Left )" : ""
                }}
              </div>
              <base-checkbox v-model="addTrusted">
                <span>Add this device as a trusted device</span>
              </base-checkbox>
              <div class="text-center">
                <base-button
                  type="primary"
                  class="my-4"
                  @click="checkSecurityQuestion"
                  >Sign In</base-button
                >
              </div>
            </form>
          </template>
        </card>
      </modal>
      <modal
        :show.sync="forgotPassword"
        body-classes="p-0"
        modal-classes="modal-dialog-centered modal-md"
      >
        <card
          shadow
          header-classes="bg-white pb-5"
          body-classes="px-lg-5 py-lg-5"
          class="border-0"
          style="color: rgba(50, 50, 93, 1) !important"
        >
          <template>
            <div class="py-3 text-center" style="padding-top: 0 !important;">
              <i
                :style="{ color: iconColor }"
                class="ni ni-key-25 ni-3x"
                style="border: 2px solid;border-radius: 50%;padding: 16px;"
              ></i>
              <p class="lead" v-if="passResetEmailShow">
                To reset your password, please enter your email address below. A
                verification code will be sent to the phone number tied to the
                account.
              </p>
              <p class="lead" v-if="passwordCodeShow">
                Enter your phone number and the verification code sent to that
                number.
              </p>
            </div>
            <form
              v-if="passResetEmailShow"
              role="form"
              @keydown.enter="sendResetPasswordCode"
              onSubmit="return false;"
            >
              <label for="emailPasswordReset">Email Address</label>
              <base-input
                id="emailPasswordReset"
                class="mb-3"
                type="email"
                placeholder="Email Address"
                addon-left-icon="fa fa-envelope-o"
                v-model="passResetEmail"
              >
              </base-input>
              <div class="text-center">
                <base-button
                  type="primary"
                  class="my-4"
                  @click="sendResetPasswordCode"
                  >Send Code</base-button
                >
              </div>
            </form>
            <form
              v-if="passwordCodeShow"
              role="form"
              @keydown.enter="checkCode"
              onSubmit="return false;"
            >
              <label for="passPhoneNumber">Phone Number</label>
              <base-input
                id="passPhoneNumber"
                class="mb-3"
                placeholder="Phone Number"
                addon-left-icon="fa fa-mobile"
                v-model="resetPhone"
              >
              </base-input>
              <label for="passwordCode">Verification Code</label>
              <base-input
                id="passwordCode"
                class="mb-3"
                placeholder="Code"
                addon-left-icon="ni ni-key-25"
                v-model="resetCode"
              >
              </base-input>
              <div class="text-center">
                <base-button type="primary" class="my-4" @click="checkCode"
                  >Validate</base-button
                >
              </div>
            </form>
            <div v-if="newPasswordShow" role="form">
              <p>
                <span>Note: </span> Password must be at least 8 characters, 1
                number, 1 capital letter, and 1 non alpha numerical character.
              </p>
              <label for="password">New Password</label>
              <small
                class="danger"
                style="color: #fb6340; margin-left: 10px"
                v-if="passMessage"
                >{{ passMessage }}</small
              >
              <base-input
                id="password"
                class="mb-6"
                type="password"
                placeholder="Password"
                addon-left-icon="ni ni-lock-circle-open"
                v-model="resetPassword"
                :valid="passValid"
                @keyup="
                  passValid = null;
                  checkPasswordStrength();
                "
                style="margin-bottom: 0px"
              >
              </base-input>
              <div class="text-muted font-italic" style="margin-bottom: 1rem">
                <small
                  >password requirements:
                  <i
                    class="fa fa-check-circle text-success"
                    v-if="validPassword"
                  ></i>
                  <i
                    class="fa fa-times-circle text-warning"
                    v-if="!validPassword"
                  ></i>
                </small>
              </div>
              <label for="confirmPassword">Confirm Password</label>
              <small
                class="danger"
                style="color: #fb6340; margin-left: 10px"
                v-if="cPassMessage"
                >{{ cPassMessage }}</small
              >
              <base-input
                id="confirmPassword"
                type="password"
                class="mb-6"
                placeholder="Confirm Password"
                addon-left-icon="ni ni-lock-circle-open"
                v-model="confirmPassword"
                :valid="cPassValid"
                @keyup="
                  cPassValid = null;
                  checkPasswordMatch();
                "
              >
              </base-input>
              <div class="text-center">
                <base-button
                  type="primary"
                  class="my-4"
                  @click="resetThePassword"
                  >Reset Password</base-button
                >
              </div>
            </div>
            <div class="success" v-if="resetSuccess">
              <div class="py-3 text-center">
                <i class="fa fa-check-circle-o fa-3x"></i>
                <h4 class="heading mt-4">password reset complete</h4>
              </div>
            </div>
            <base-alert type="danger" v-if="resetError">
              {{ resetError }}
            </base-alert>
          </template>
        </card>
      </modal>
      <modal
        :show.sync="limitError"
        gradient="danger"
        modal-classes="modal-danger modal-dialog-centered"
      >
        <h6 slot="header" class="modal-title" id="modal-title-notification" style="color: white !important; font-weight: bold;">
          Account Locked Out
        </h6>

        <div class="py-3 text-center">
          <i class="fa fa-lock fa-3x"></i>
          <h4 class="heading mt-4" style="color: white !important; font-weight: bold;">{{ limitMessage }}</h4>
          <p class="lead">
            Please contact our offices or loan officer to unlock your account.
          </p>
        </div>

        <template slot="footer">
          <base-button
            type="link"
            text-color="white"
            class="ml-auto"
            @click="limitError = false"
          >
            Close
          </base-button>
        </template>
      </modal>
    </div>
  </section>
</template>
<script>
import {
  login,
  verifyTrustedDevice,
  sendPassResetCode,
  checkPhoneCode,
  resetUsersPassword,
  validatePassword,
} from "../services/auth.js";
export default {
  data() {
    return {
      email: "",
      password: "",
      loading: false,
      emailValid: null,
      passValid: null,
      checking: false,
      error: false,
      questions: false,
      questionModal: false,
      answer: "",
      addTrusted: false,
      limitError: false,
      limitMessage: "",
      attemptsLeft: null,
      deviceError: null,
      quValid: null,
      forgotPassword: false,
      passResetEmailShow: true,
      passResetEmail: "",
      passwordCodeShow: false,
      newPasswordShow: false,
      resetCode: "",
      resetPhone: "",
      resetError: null,
      cPassValid: null,
      confirmPassword: "",
      resetPassword: "",
      cPassMessage: null,
      passMessage: null,
      validPassword: false,
      resetSuccess: false,
      redirect: null,
      logoLight: this.$theme.logo.light,
      logoDark: this.$theme.logo.dark,
      iconColor: this.$theme.primary,
      iconSuccess: this.$theme.success,
    };
  },
  created() {
    if (this.$route.params.referral) {
      window.sessionStorage.setItem("referral", this.$route.params.referral);
    }
    window.addEventListener("theme", () => {
      this.logoLight = this.$theme.logo.light;
      this.logoDark = this.$theme.logo.dark;
      this.iconColor = this.$theme.primary;
      this.iconSuccess = this.$theme.success;
    });
  },
  methods: {
    async attemptLogin() {
      this.error = false;
      if (!this.email.length || !this.password.length) {
        this.emailValid = this.email.length ? true : false;
        this.passValid = this.password.length ? true : false;
      } else {
        this.checking = true;
        this.emailValid = true;
        this.passValid = true;
        this.loading = true;
        let res = await login(this.email, this.password);
        // console.log(res)
        if (res.status == 429 && res.blocked) {
          window.location.reload();
          return
        }
        if (res.status == 400 || res.status == 401 || res.status == 500) {
          this.loading = false;
          this.checking = true;
          this.emailValid = null;
          this.attemptsLeft = res.attemptsLeft >= 0 ? res.attemptsLeft : null;
          this.error = res.message;
          this.passValid = null;
        } else if (res.status == 200 && res.trusted) {
          setTimeout(() => {
            this.checking = false;
          }, 1000);
          setTimeout(() => {
            this.$router.push("/");
          }, 3000);
        } else if (res.status == 200 && !res.trusted) {
          this.questions = res.questions;
          this.attemptsLeft = null;
          this.questionModal = true;
          this.loading = false;
          this.checking = false;
          this.emailValid = null;
        } else if (res.status == 429) {
          this.loading = false;
          this.checking = false;
          this.emailValid = null;
          this.limitMessage = res.message;
          this.limitError = true;
        }
      }
    },
    async checkSecurityQuestion() {
      let res = await verifyTrustedDevice({
        email: this.email,
        password: this.password,
        answer: this.answer,
        add: this.addTrusted,
        id: this.questions.ID,
      });
      if (res.status == 400 || res.status == 401 || res.status == 500) {
        this.loading = false;
        this.checking = true;
        this.quValid = false;
        this.attemptsLeft = res.attemptsLeft >= 0 ? res.attemptsLeft : null;
        this.deviceError = res.message;
      } else if (res.status == 200 && res.trusted) {
        this.questionModal = false;
        this.attemptLogin();
      } else if (res.status == 429 && res.locked) {
        this.loading = false;
        this.checking = false;
        this.emailValid = null;
        this.limitMessage = res.message;
        this.limitError = true;
        this.questionModal = false;
      }
    },
    async sendResetPasswordCode() {
      let res = await sendPassResetCode(this.passResetEmail);
      if (res.status === 200) {
        this.passResetEmailShow = false;
        this.passwordCodeShow = true;
      } else {
        this.resetError = res.message;
      }
    },
    async checkCode() {
      if (this.resetPhone[0] != '1') {
        this.resetPhone = '1' + this.resetPhone
      }
      let res = await checkPhoneCode(this.resetPhone, this.resetCode);
      if (!res) {
        this.resetError = "PhoneNumber or code are incorrect.";
      }
      if (res) {
        this.passwordCodeShow = false;
        this.newPasswordShow = true;
        this.resetError = null;
      }
    },
    async checkPasswordMatch() {
      this.cPassMessage = null;
      if (this.resetPassword !== this.confirmPassword) {
        this.cPassValid = false;
        this.cPassMessage = "Passwords do not match.";
      } else {
        this.cPassValid = true;
      }
    },
    async checkPasswordStrength() {
      if (!this.resetPassword.length) {
        this.passValid = false;
        return;
      }
      this.passMessage = null;
      this.validPassword = await validatePassword(this.resetPassword);
      if (this.validPassword) {
        this.passValid = true;
      } else {
        this.passValid = false;
        this.passMessage = "Passwords does not meet requirements.";
      }
    },
    async resetThePassword() {
      if (this.validPassword) {
        let res = await resetUsersPassword({
          email: this.passResetEmail,
          phone: this.resetPhone,
          code: this.resetCode,
          password: this.resetPassword,
        });
        if (res.status === 200) {
          this.newPasswordShow = false;
          this.resetSuccess = true;
          this.resetPassword = "";
          this.confirmPassword = "";
          this.resetCode = "";
          setTimeout(() => {
            this.forgotPassword = false;
            this.email = this.passResetEmail;
          }, 2000);
        } else {
          this.resetError = res.message;
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.newApp {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #525f82;
  h3 {
    margin-bottom: 20px;
    color: #172b4d;
    font-weight: lighter;
  }
}
form {
  h4 {
    margin-bottom: 20px;
    color: #172b4d;
    font-weight: lighter;
    text-align: center;
    font-size: 20px;
  }
}
.logoHolder {
  display: flex;
  .logo {
    max-width: 200px;
    max-height: 120px;
    margin: 40px auto 60px;
  }
}
.col-sm {
  margin: 0 40px;
}
.divider {
  border-right: 1px solid #adb5bd;
}
.loader {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 10;
  opacity: 0;
  margin-top: 40px;
}
.loader-box {
  width: 120px;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  position: relative;
  i {
    font-size: 30px;
  }
}
.alert-inner--text {
  max-width: 280px;
}
.unlock {
  opacity: 0;
  color: #2dce89;
  animation: scale 1.2s linear 0s forwards;
}
.border-1 {
  position: absolute;
  width: 100px;
  height: 100px;
  padding: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 2px solid #2dce89;
}
.border-2 {
  position: absolute;
  width: 100px;
  height: 100px;
  padding: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 2px solid #5e72e4;
}

.spin1 {
  animation: spin3D 1.8s linear 0s infinite;
}
.spin2 {
  animation: spin3D 2.2s linear 0s infinite;
}
.spin3 {
  animation: spin3D 2.2s linear 0s forwards;
}
.opacityChange {
  animation: opacityFade 1.2s linear 0s forwards;
}
.bringOut {
  animation: fadeIn 1.2s linear 0s backwards;
}
.bringIn {
  animation: fadeIn 1.2s linear 0s forwards;
}
@keyframes scale {
  form {
    font-size: 10px;
    opacity: 0;
  }
  to {
    font-size: 40px;
    opacity: 1;
  }
}

@keyframes fadeIn {
  form {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes opacityFade {
  form {
    opacity: 1;
  }
  to {
    opacity: 0.2;
  }
}

@media (max-width: 575px) {
  .newApp {
    margin-bottom: 60px;
  }
  .section {
    padding: 10px 0;
  }
  .logoHolder {
    .logo {
      margin: 40px auto 20px;
    }
  }
  .col-sm {
    margin: 20px;
  }
  .divider {
    border-bottom: 1px solid #adb5bd;
    width: 100%;
  }
}
</style>
